module.exports = __webpack_public_path__ + "static/media/not-found-nft.522bb135.jpg";